





































































import { Component, Provide, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {
    ElementBgIcon: () => import('@/components/elements/ElementBgIcon.vue'),
  },
})
export default class ElementUpdateSolesSelectSation extends Vue {
  @Prop({ default: false }) protected loading!: boolean;

  @Provide() selectedStation: any = null; // selected Station

  get stations() {
    return this.$pdc.entities!.stations.storedEntity.list;
  }

  @Watch('selectedStation', { deep: true })
  selectedTypeChange() {
    this.$emit('selectedStation', {
      station: this.selectedStation,
      auto: false,
    });
  }
}
